import { render, staticRenderFns } from "./DoanhThuNgoaiForm.vue?vue&type=template&id=1c53d0e0&"
import script from "./DoanhThuNgoaiForm.vue?vue&type=script&lang=js&"
export * from "./DoanhThuNgoaiForm.vue?vue&type=script&lang=js&"
import style0 from "./DoanhThuNgoaiForm.vue?vue&type=style&index=0&id=1c53d0e0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports